__turbopack_context__.v({
  "profile_icon": "UserImageInitial-module-scss-module__kwn9Tq__profile_icon",
  "profile_initial_thumbnail": "UserImageInitial-module-scss-module__kwn9Tq__profile_initial_thumbnail",
  "profile_passport_compass": "UserImageInitial-module-scss-module__kwn9Tq__profile_passport_compass",
  "user": "UserImageInitial-module-scss-module__kwn9Tq__user",
});
